import React from "react";
import { AnalysisTabs } from "../../common/dynamicanalysis";
import Behavior from "./behavior/Behavior";
import Network from "./network/Network";
import Domains from "./domains/Domains";
import Mutexes from "./mutexes/Mutexes";
import { enums } from "../../../../../shim/jsbridge";

const {
  dynamic_analysis_routes: { NETWORK_ANALYSIS, BEHAVIORAL, DOMAIN, MUTEX }
} = enums || {};

const Analysis = () => {
  const titles = [
    {
      key: BEHAVIORAL,
      title: "Behavioral"
    },
    {
      key: NETWORK_ANALYSIS,
      title: "Network"
    },
    {
      key: DOMAIN,
      title: "Domains/IPs/URLs"
    },
    {
      key: MUTEX,
      title: "Mutexes"
    }
  ];

  const items = [
    {
      key: BEHAVIORAL,
      component: <Behavior />
    },
    {
      key: NETWORK_ANALYSIS,
      component: <Network />
    },
    {
      key: DOMAIN,
      component: <Domains />
    },
    {
      key: MUTEX,
      component: <Mutexes />
    }
  ];

  return <AnalysisTabs analysis="joe" items={items} titles={titles} />;
};

export default Analysis;
